import { moveToFulfilled } from '@ms/yammer-data-support';
import { Reducer } from 'redux';

import {
  FeedLoadAction,
  FeedLoadNewerThreadsFulfilledAction,
  FeedLoadOlderThreadsFulfilledAction,
} from '../../domains/feedLoad/actions.types';
import { UserNetworkLeadersListLoadFulfilledAction } from '../../domains/leadersManagement/loadAllLeadersActions.types';
import { UserNetworkLeadersListLoadMoreFulfilledAction } from '../../domains/leadersManagement/loadMoreAllLeadersActions.types';
import { NestedThreadListLoadFulfilledAction } from '../../domains/nestedThreadList/actions.types';
import { NotificationLoadMoreFulfilledAction } from '../../domains/notificationPaginations/actions.types';
import { SuggestedActionsLoadFulfilledAction } from '../../domains/suggestedActions/actions.types';
import { SuggestedLeadersLoadAction } from '../../domains/suggestedLeaders/loadActions.types';
import { SuggestedLeadersLoadMoreAction } from '../../domains/suggestedLeaders/loadMoreActions.types';
import { SuggestedUsersLoadAction } from '../../domains/suggestedUsers/loadActions.types';
import { SuggestedUsersLoadMoreAction } from '../../domains/suggestedUsers/loadMoreActions.types';
import { UserFollowedByLoadAction } from '../../domains/userFollowedBy/actions.types';
import { UserFollowedUsersLoadAction } from '../../domains/userFollowedUsers/actions.types';
import { UserHeaderLoadAction } from '../../domains/userHeaderLoad/actions.types';

import { ViewerIsFollowedByUsers } from './types';

export type ViewerIsFollowedByUsersAction =
  | FeedLoadAction
  | FeedLoadNewerThreadsFulfilledAction
  | FeedLoadOlderThreadsFulfilledAction
  | UserHeaderLoadAction
  | UserFollowedUsersLoadAction
  | UserFollowedByLoadAction
  | NotificationLoadMoreFulfilledAction
  | NestedThreadListLoadFulfilledAction
  | SuggestedActionsLoadFulfilledAction
  | SuggestedLeadersLoadAction
  | SuggestedLeadersLoadMoreAction
  | SuggestedUsersLoadAction
  | SuggestedUsersLoadMoreAction
  | UserNetworkLeadersListLoadFulfilledAction
  | UserNetworkLeadersListLoadMoreFulfilledAction;

const initialState: ViewerIsFollowedByUsers = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<ViewerIsFollowedByUsers, ViewerIsFollowedByUsersAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'FEED.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.viewerIsFollowedByUsers);
    case 'FEED.LOAD_NEWER_THREADS_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.viewerIsFollowedByUsers);
    case 'FEED.LOAD_OLDER_THREADS_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.viewerIsFollowedByUsers);
    case 'USER_HEADER.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.viewerIsFollowedByUsers);
    case 'SUGGESTED_LEADERS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.viewerIsFollowedByUsers);
    case 'SUGGESTED_LEADERS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.viewerIsFollowedByUsers);
    case 'SUGGESTED_USERS.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.viewerIsFollowedByUsers);
    case 'SUGGESTED_USERS.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.viewerIsFollowedByUsers);
    case 'ALL_LEADERS_IN_USERS_NETWORK.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.viewerIsFollowedByUsers);
    case 'ALL_LEADERS_IN_USERS_NETWORK.LOAD_MORE_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.viewerIsFollowedByUsers);
    case 'USER_FOLLOWED_BY.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.viewerIsFollowedByUsers);
    default:
      return state;
  }
};

export default reducer;
